/**
 * Makes a user event text string
 * @param {Object} options
 * @param {String} options.status - the activity status of user
 * @returns {String} - User Event
 */
const user = ({ status }) => {
  if (status) return `user-${status}`;
};

module.exports = user;
